// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2oqyO","title":"Info_title__MwRO0","selects":"Info_selects__LHBZb","requiredAsterisk":"Info_requiredAsterisk__3h8dR"};